import script from "./LiveFixtureDoubleMarket.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveFixtureDoubleMarket.vue?vue&type=script&setup=true&lang=js"

import "./LiveFixtureDoubleMarket.vue?vue&type=style&index=0&id=e0bc52be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0bc52be"]])

export default __exports__